<ion-button id="open-loading" style="display:none;"></ion-button>
<ion-loading 
    trigger="open-loading" 
    [message]="loadingMessage"
    [spinner]="loadingType"
    [animated]="true"
    >
</ion-loading>